/**
 * Toggle Component
 *
 * Toggle switch with label and description.
 *
 * @package PresszoneComments
 */

import { el } from '../utils/dom.js';

/**
 * Render a toggle switch row.
 *
 * @param {string} key - State key
 * @param {string} title - Toggle label
 * @param {string} description - Help text
 * @param {Object} state - State object containing value
 * @param {Function} onUpdate - Callback when value changes (key, value)
 * @param {boolean} isWarning - Use warning styling
 */
export function Toggle(key, title, description, state, onUpdate, isWarning = false) {
    const isActive = !!state[key];

    const toggle = el('button', {
        type: 'button',
        role: 'switch',
        'aria-checked': isActive ? 'true' : 'false',
        'aria-label': title,
        class: `presszone-comments-toggle ${isActive ? 'presszone-comments-toggle--active' : ''} ${isWarning ? 'presszone-comments-toggle--warning' : ''}`,
        onclick: () => {
            const newValue = !state[key];
            state[key] = newValue;
            toggle.classList.toggle('presszone-comments-toggle--active');
            toggle.setAttribute('aria-checked', newValue ? 'true' : 'false');
            if (onUpdate) onUpdate(key, newValue);
        },
        onkeydown: (e) => {
            // Space and Enter toggle the switch
            if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                toggle.click();
            }
        }
    });

    return el('div', { class: 'presszone-comments-toggle-row' },
        el('div', { class: 'presszone-comments-toggle__label' },
            el('span', { class: 'presszone-comments-label--settings' }, title),
            description ? el('span', { class: 'presszone-comments-toggle-row__desc' }, description) : null
        ),
        toggle
    );
}

export default Toggle;
